<template lang="pug">
  .add-wa-form
    y-dialog(v-model="showModal" fill-height fluid scrollable persistent :fullscreen="$vuetify.breakpoint.xsOnly && member.role !== 'Agent' && member.role !== 'Salesperson'" transition="fade-transition" max-width="600px")
      v-card
        v-card-title.px-5(:style="`background-color: ${$vuetify.theme.themes[$theme].basic600T16}`")
          v-row(no-gutters align="center")
            v-col.shrink
              v-btn.ml-n3(text icon @click="showModal = !showModal" height)
                v-icon(color="basic800" :size="24") mdi-close
            v-col.ml-3
              p.mb-0.h6.basic800--text {{ member.role === 'Agent' ? 'Customize link' : form ? $t('edit_wa_form') : $t('create_wa_form') }}

        v-card-text.pa-0
          v-form(ref="form")
            v-card.pa-4
              template(v-if="member.role !== 'Agent' && member.role !== 'Salesperson'")
                .form-name
                  p.mb-1.label.basic600--text.text-uppercase {{ $t('form_name.label') }}*
                  v-text-field.mt-2(v-model='formName' background-color="basic200" height="40" outlined dense persistent-hint counter :maxlength="100" :placeholder="$t('form_name.placeholder')" :rules="rules.not_empty")

                p.h6.basic1000--text.mt-5.mb-1 {{ $t('data_collection') }}
                p.mb-0.p2.primary400--text {{ $t('customer_explain') }}

                v-card.mt-4(outlined)
                  v-simple-table(fixed-header)
                    template(v-slot:default)
                      thead
                        tr
                          th.text-left.basic200.primary400--text.pr-1.pl-3 {{ $t('customer_info') }}
                          th.text-center.basic200.primary400--text.px-1 {{ $t('include') }}
                          th.text-center.basic200.primary400--text.px-1 {{ $t('required') }}
                          th.text-center.basic200.primary400--text.px-3(v-if="extraFields.length != 0") {{ $t('actions') }}
                      tbody
                        tr
                          td.py-2.pr-1.pl-3
                            div.p2.primary--text {{ selectedLang.nameLabel }}
                          td.px-1(align="center")
                            v-row(no-gutters justify="center")
                              v-col.shrink
                                y-checkbox.mb-n2(v-model="customerName" hide-details readonly disabled)
                          td.px-1
                            v-row(no-gutters justify="center")
                              v-col.shrink
                                y-checkbox.mb-n2(v-model="customerName" hide-details readonly disabled)
                          td.pl-1(v-if="extraFields.length != 0")

                        tr
                          td.py-2.pr-1.pl-3
                            div.p2.primary--text {{ selectedLang.phoneLabel }}
                          td.px-1
                            v-row(no-gutters justify="center")
                              v-col.shrink
                                y-checkbox.mb-n2(v-model="customerPhone" hide-details readonly disabled)
                          td.px-1
                            v-row(no-gutters justify="center")
                              v-col.shrink
                                y-checkbox.mb-n2(v-model="customerPhone" hide-details readonly disabled)
                          td.pl-1(v-if="extraFields.length != 0")

                        tr
                          td.py-2.pr-1.pl-3
                            div.p2.primary--text {{ selectedLang.emailLabel }}
                          td.px-1
                            v-row(no-gutters justify="center")
                              v-col.shrink
                                y-checkbox.mb-n2(v-model="customerEmail" hide-details)
                          td.px-1
                            v-row(no-gutters justify="center")
                              v-col.shrink
                                y-checkbox.mb-n2(v-model="emailIsRequired" hide-details :disabled="!customerEmail")
                          td.pl-1(v-if="extraFields.length != 0")

                      draggable.extra-fields(v-model="extraFields" handle=".handle" tag="tbody" @start="drag=true"  @end="drag=false")
                        template(v-for="(extraField, fieldIndex) in extraFields")
                          extra-form-field(:key="extraField.name + fieldIndex" :field="extraField" :index="fieldIndex" @deleted="handleDeleteItem" @edited="handleFieldEdited")
                      tbody
                        tr
                          td(:colspan="extraFields.length > 0 ? '4' : '3'" style="height: 40px;border-top: thin solid rgba(0, 0, 0, 0.12);")
                            div(align="center")
                              v-btn.button-Aa-small.custom-transform-class.text-none(color="textColorAccent" text @click="showAddExtraDialog = true" small)
                                v-icon.mr-2(color="textColorAccent" size="17") mdi-plus
                                | {{$t('collect_extra_info')}}

                div.d-flex.align-center.mt-3
                  div.mr-2.p2.primary500--text {{ $t('use_wa_form') }}
                  v-menu(left :offset-y='true')
                    template(v-slot:activator='{ on }')
                      v-chip.px-3(color="basic300" small label v-on="on")
                        div.button-AA-tiny.primary--text.text-uppercase {{ getFormLanguageDisplay() }}
                        v-icon.ml-1(right small) mdi-chevron-down
                    v-list
                      v-list-item.my-n2(v-for="(language, index) in languages" :key="language.id" @click="formLanguage = language.id")
                        v-list-item-title.p2 {{ language.name }}

                v-btn.button-Aa-small.custom-transform-class.text-none.px-2.mt-4(color="textColorAccent" text @click="showMessageTemplateDialog = true" small)
                  eva-icon.mt-1.mr-2(name="edit-outline" :fill="$vuetify.theme.themes[$theme].textColorAccent" height="14" width="14")
                  | {{ $t('edit_message_template') }}

                div.d-flex.align-center.mt-6
                  p.h6.basic1000--text.mb-0 {{ $t('attach_products') }}
                  v-spacer
                  v-btn.button-AA-tiny(color="textColorAccent" outlined x-small height="24" :style="{'background-color': $vuetify.theme.themes[$theme].infoT08}" @click='showAttachProductsDialog = true')
                    v-icon.mr-1(small) mdi-plus
                    | {{ $t('add_product') }}

                .attach-product.mt-2
                  p.mb-1.label.basic600--text.text-uppercase {{ $t('products') }}
                  v-select.my-2(v-model="products" background-color="basic200" outlined dense hide-no-data chips hide-details multiple readonly :items="products" :menu-props="({'closeOnContentClick': false})" placeholder="Add Products" :loading="productSearchLoading" ref="selectProducts" type="button" append-icon="")
                    template(v-slot:selection="{ attrs, item, select, selected }")
                      v-chip.mt-1.s2(outlined :style="`background-color: ${$vuetify.theme.themes[$theme].basic600T08}`" close-icon="mdi-close" v-bind="attrs" small close :color="item.status === 'draft' ? 'danger' : 'basic600'" :input-value="selected" @click:close="removeProd(item)")
                        span(v-if="item.name") {{ item.name.length > 25 ? (item.name.substr(0,25) + '...') : item.name }}{{ item.status === 'draft' ? ' (draft)' : '' }}
                  //- div.d-flex.mt-4
                    y-checkbox.ma-0.pa-0(v-model="showProductStock" hide-details)
                      template(v-slot:label)
                        .p1.primary--text Show product stock quantity
                  div.d-flex.mt-4
                    y-checkbox.ma-0.pa-0(v-model="hideSoldoutProducts" hide-details)
                      template(v-slot:label)
                        .p1.primary--text {{ $t('hide_soldout_product') }}

                  p.h6.basic1000--text.mt-6 {{ $t('display_product_inventory') }}
                  v-radio-group.mt-2(v-model='showProductInventory' row dense hide-details)
                    v-radio(label='Hidden', value='hidden')
                      template(v-slot:label)
                        div.p1.textColorDefault--text {{ $t('hidden') }}
                    v-radio(label='Always', value='always')
                      template(v-slot:label)
                        div.p1.textColorDefault--text {{ $t('always') }}
                    v-radio(label='Only when low', value='low')
                      template(v-slot:label)
                        div.p1.textColorDefault--text {{ $t('only_when_low') }}

                p.h6.basic1000--text.mt-6.mb-2 {{ $t('choose_layout') }}
                .choose-layout
                  p.mb-1.label.basic600--text.text-uppercase {{ $t('layouts') }}
                  v-select.my-2(ref="layoutSelect" v-model="selectedStyle" background-color="basic200" height="40" item-value="value" :items="items" outlined dense)
                    template(v-slot:item="{ index, item }")
                      v-layout
                        v-list-item-content
                          v-list-item-title {{ item.text }}
                        v-list-item-action(v-if="item.value != 'inquiry'")
                          v-btn.mr-2.black--text(color="black" depressed outlined x-small @click.stop="clickShowFormExample(item.value)") {{ $t('example') }}

                div.d-flex.align-center.mt-2
                  p.h6.basic1000--text.mb-0 {{ $t('whos_selling') }}
                  v-spacer
                  v-btn(color="primary" icon @click="sales_keyboard = !sales_keyboard" small)
                    v-icon(color="primary") {{ sales_keyboard ? 'mdi-keyboard-outline' : 'mdi-keyboard-off-outline' }}

                .who-selling.mt-2
                  p.mb-1.label.basic600--text.text-uppercase {{ $t('sellers') }}*
                  v-combobox.mt-2(v-model="members" background-color="basic200" outlined dense hide-selected hide-no-data hide-details multiple chips placeholder="Select sellers" ref="selectMembers" :search-input.sync="memberSearch" :loading="memberSearchLoading" :items="memberList" :item-text="getMemberSearchText" :rules="rules.not_empty" :menu-props="({ 'closeOnContentClick': false, 'maxHeight': sales_keyboard ? '35%' : '45%' })" :type="sales_keyboard ? 'text' : 'button'" @change="onMemberFilterChanged")
                    template(v-slot:selection="{ attrs, item, select, selected }")
                      v-chip.s2.mb-1(:style="`background-color: ${$vuetify.theme.themes[$theme].basic600T08}`" v-bind="attrs" outlined small close :color="item.status === 'inactive' ? 'danger' : 'basic600'" :input-value="selected" @click:close="removeSales(item)" close-icon="mdi-close")
                        span {{ item.user.first_name }} {{ item.user.last_name }}{{ item.status === 'inactive' ? ' (inactive)' : '' }}
                    template(v-slot:item="{ index, item }")
                      v-layout
                        intel-avatar.mr-3(:code="item.user.avatar_code" :id="item.user.id" size=48)
                        v-list-item-content
                          v-list-item-title(v-text="item.user.first_name + ' ' + item.user.last_name + (item.status === 'inactive' ? ' (inactive)' : '')")
                          v-list-item-subtitle(v-text="item.role")

                div.d-flex.mt-4
                  y-checkbox.ma-0.pa-0(v-model="allowBypass" hide-details @change="updateFormType()")
                    template(v-slot:label)
                      .p1.primary--text {{ $t('allow_proceed_to') }}

              template(v-if="Auth('root', 'custom_link')")
                p.h6.basic1000--text.mt-8.mb-2 {{ $t('custom_link') }}
                  //- span.basic500--text (optional)
                .choose-layout
                  p.mb-1.label.basic600--text.text-uppercase {{ $t('form_url') }}
                  v-text-field.my-2(v-model='customLink' background-color="basic200" height="40" outlined dense persistent-hint counter placeholder="custom_link" :prefix="`https://${this.company.slug}.yezza.io/`" :maxlength="50")

              template(v-if="member.role !== 'Agent' && member.role !== 'Salesperson' ")
                .min-order(v-if="company.genes.find(g => g.feature === 'min_order_amount')")
                  p.h6.basic1000--text.mt-4 {{ $t('min_order_amount') }}
                  y-checkbox.mt-3.mx-0.pa-0(v-model="hasMinOrder" hide-details)
                    template(v-slot:label)
                      div.p1.my-auto {{ $t('this_form_has') }}
                  .minorder.mt-4(v-if="hasMinOrder")
                    p.mb-1.label.basic600--text.text-uppercase {{ $t('amount') }}*
                    v-text-field.my-2(v-model="minOrderAmount" background-color="basic200" height="40" outlined dense placeholder="0" :prefix="$currency.symbol" type="number" :rules="rules.has_quantity")

                template(v-if="form && zones.length > 0")
                  p.h6.basic1000--text.mt-8.mb-4 {{ $t('advance_shipping_setting') }}
                  form-zones-shipping(:company="company" :form="form" :szones="zones" :excludedZones.sync="excludedZones" :parentOrderSettings.sync="orderSettings")
                  //- v-btn.button-Aa-small.custom-transform-class.text-none.px-2(color="textColorAccent" text @click='showFormZonesDialog = true' small)
                    eva-icon.mt-1.mr-2(name="pantone-outline" :fill="$vuetify.theme.themes[$theme].textColorAccent" height="14" width="14")
                    | Manage Shipping Zones
              div.mb-8
        v-card-actions
          v-spacer
          v-btn(color='white', text @click='showModal = false')
            .button-Aa-medium.primary400--text {{ $t('cancel') }}
          v-btn.mr-2(color='textColorAccent' depressed height=32 @click="checkSave" :loading="isLoading" dark)
            .button-AA-medium.basic100--text(v-if="form") {{ $t('save') }}
            .button-AA-medium.basic100--text(v-else) {{ $t('create') }}

    .modals
      add-wa-extra-field(v-if="showAddExtraDialog" :open.sync="showAddExtraDialog" @added="handleFieldAdded")
      add-wa-message-template(v-if="showMessageTemplateDialog" :fields="extraFields" :hasProduct="products.length > 0" :open.sync="showMessageTemplateDialog" :message.sync="messageTemplate")
      attach-products(v-if="showAttachProductsDialog" :open.sync="showAttachProductsDialog" :initialProducts.sync="products" excludeBundles)
      //- edit-form-zones(v-if="showFormZonesDialog" :open.sync="showFormZonesDialog" :company="company" :form="form" :szones="zones" :excludedZones.sync="excludedZones")
      y-dialog(v-if="showFormExampleDialog" v-model='showFormExampleDialog' scrollable='' max-width='600px')
        v-card
          v-card-title.px-4.h6.basic800--text {{ $t('form_example') }} 
            span.text-capitalize.pl-1 ({{ selectedExample }})
          v-divider.basic300
          v-card-text.pt-6
            v-img(v-if="selectedExample == 'card'" :src="require('@/assets/images/waform/wa_example_card.png')")
            v-img(v-if="selectedExample == 'list'" :src="require('@/assets/images/waform/wa_example_list.png')")
            v-img(v-if="selectedExample == 'dropdown'" :src="require('@/assets/images/waform/wa_example_dropdown.png')")
          v-card-actions
            v-spacer
            v-btn(color="white" text @click="showFormExampleDialog = false")
              .button-AA-small.primary400--text {{ $t('close') }}
</template>

<script>
import { mapActions, mapState } from 'vuex'
import draggable from 'vuedraggable'
import ExtraFormField from '@/components/ExtraFormField.vue'
import AddWaExtraField from '@/components/dialogs/AddWaExtraField.vue'
import EditFormZones from '@/components/dialogs/EditFormZones.vue'
import FormZonesShipping from '@/components/FormZonesShipping.vue'
import AttachProducts from '@/components/dialogs/AttachProducts.vue'
import AddWaMessageTemplate from '@/components/dialogs/AddWaMessageTemplate.vue'
import IntelAvatar from '@/components/IntelAvatar.vue'
export default {
  name: 'AddWaForm',
  props: ['open', 'company', 'parentForm'],
  components: { ExtraFormField, AddWaExtraField, AddWaMessageTemplate, AttachProducts, IntelAvatar, EditFormZones, FormZonesShipping, draggable},
  data: () => ({
    items: [
      { text: 'Dropdown (single selection)', value: 'dropdown' }, 
      { text: 'Card (multiple selection)', value: 'card' }, 
      { text: 'List (multiple selection)', value: 'list' }, 
      { text: 'Inquiry (no products)', value: 'inquiry' }
    ],
    formName: null,
    formSlug: '',
    customerName: true,
    customerPhone: true,
    customerEmail: false,
    emailIsRequired: false,
    showAddExtraDialog: false,
    showMessageTemplateDialog: false,
    productSearchLoading: false,
    showAttachProductsDialog: false,
    showFormExampleDialog: false,
    showFormZonesDialog: false,
    hasMinOrder: false,
    extraField: {
      name: '',
      type: 0,
      required: true,
      enabled: true,
    },
    extraFields: [],
    messageTemplate: '',
    formLanguage: 'en',
    products: [],
    selectedStyle: 'card',
    isLoading: false,
    members: '',
    memberSearch: null,
    memberSearchLoading: false,
    memberList: [],
    zones: [],
    excludedZones:[],
    hideSoldoutProducts: false,
    showProductStock: false,
    showProductInventory: 'hidden',
    languages: [
      { name: 'English', id: 'en' },
      { name: 'Bahasa Malaysia', id: 'ms' },
      { name: 'Bahasa Indonesia', id: 'id' },
      { name: 'Chinese', id: 'zh' },
      { name: 'Tamil', id: 'ta' }
    ],
    langLabel: [
      {
        id: 'en',
        nameLabel: 'Name',
        phoneLabel: 'Phone',
        emailLabel: 'Email'
      },
      {
        id: 'ms',
        nameLabel: 'Nama',
        phoneLabel: 'No Telefon',
        emailLabel: 'E-mel'
      },
      {
        id: 'id',
        nameLabel: 'Nama',
        phoneLabel: 'Nomor Telepon',
        emailLabel: 'Email'
      },
      {
        id: 'zh',
        nameLabel: '姓名',
        phoneLabel: '电话号码',
        emailLabel: '电子邮件'
      },
      {
        id: 'ta',
        nameLabel: 'பெயர்',
        phoneLabel: 'தொலை பேசி இலக்கம்',
        emailLabel: 'மின் அஞ்சல்'
      }
    ],
    allowBypass: false,
    formType: 'whatsapp',
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      has_quantity: [(v) => !!v || 'This field is required', (v) => v != 0|| 'This field is required']
    },
    sales_keyboard: false,
    customLink: null,
    customLinkId: null,
    minOrderAmount: null,
    orderSettings: null,
  }),
  computed: {
    ...mapState('user', ['member']),
    form: {
      get() {
        return this.parentForm
      },
      set(newValue) {
        this.$emit('update:parentForm', newValue)
      }
    },
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    selectedLang () {
      return this.langLabel.find(f => f.id === this.formLanguage)
    }
  },
  watch: {
    memberSearch () {
      if (this.memberList.length != 0) {
        return
      }
      this.startSearchMembers()
    },
    showFormExampleDialog (val) {
      if (!val) {
        setTimeout(() => {
          this.openLayoutSelect()
        }, 50)
      }
    }
  },
  mounted () {
    this.startSearchMembers()
    this.fetchZones()
    this.fetchOrderSettings()
    if (this.form) {
      this.formName = this.form.name
      this.formSlug = this.form.slug
      this.customerEmail = this.form.email_enabled
      this.emailIsRequired = this.form.email_required
      if (this.form.extra_fields) {
        this.extraFields = this.form.extra_fields
      }
      this.messageTemplate = this.form.message_template
      this.formLanguage = this.form.language || 'en'
      this.formType = this.form.type
      if (this.form.type == 'both') {
        this.allowBypass = true
      }
      this.products = this.form.products
      this.selectedStyle = this.form.layout
      this.productSearchLoading = true
      this.$axios.get(`/forms/${this.form.id}/`)
        .then((response) => {
          this.products = response.data.products
          this.members = response.data.members
          this.formName = response.data.name
          this.formSlug = response.data.slug
          this.messageTemplate = response.data.message_template
          this.customerEmail = response.data.email_enabled
          this.emailIsRequired = response.data.email_required
          this.excludedZones = response.data.excluded_zones
          this.hideSoldoutProducts = response.data.hide_soldout_products
          this.showProductStock = response.data.show_stock
          if (response.data.min_amount) {
            this.minOrderAmount = response.data.min_amount/this.$currency.multiplier
            this.hasMinOrder = true
          }
          if (response.data.extra_fields) {
            this.extraFields = response.data.extra_fields
          }
          if (response.data.show_stock_level) {
            this.showProductInventory = 'always'
          } else if (response.data.show_stock_level_when_low) {
            this.showProductInventory = 'low'
          }
        })
        .catch(() => {})
        .finally(() => {
          this.productSearchLoading = false
        })
      let url = this.member.role === 'Agent' ? `member=${this.member.id}` : 'without_member=true'
      this.$axios.get(`/forms/${this.form.id}/slugs/?${url}`)
        .then(resp => {
          // console.log(resp.results)
          if (resp.data.results.length > 0) {
            this.customLink = resp.data.results[0].slug
            this.customLinkId = resp.data.results[0].id
          }
        })
        .catch(() => {})
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    clickShowFormExample (value) {
      this.showFormExampleDialog = true
      this.selectedExample = value
    },
    getFormLanguageDisplay () {
      const selectedLanguage = this.languages.filter((obj) => {
        return obj.id == this.formLanguage
      })
      if (selectedLanguage.length > 0) {
        return selectedLanguage[0].name
      }
      return this.formLanguage
    },
    updateFormType () {
      if (this.allowBypass) {
        this.formType = 'both'
      } else {
        this.formType = 'whatsapp'
      }
    },
    startSearchMembers() {
      this.memberSearchLoading = true
      this.$axios.get(`/members/?page_size=-1&company=${this.company.id}`)
        .then(resp => {
          this.memberList = resp.data.results
        })
        .catch(() => {})
        .finally(() => (this.memberSearchLoading = false))
    },
    getMemberSearchText (item) {
      return item.user.first_name + ' ' + item.user.last_name + ' ' + item.user.email
    },
    fetchZones () {
      this.$axios.get(`/shipping/settings/${this.company.slug}/zones/?page_size=-1`)
        .then((response) => {
          if (response.data.results) {
            this.zones = response.data.results
          }
        }).catch(() => {})
    },
    fetchOrderSettings () {
      this.$axios.get(`/oms/${this.company.slug}/`)
        .then((response) => {
          this.orderSettings = response.data
        })
        .catch(() => {})
    },
    handleDeleteItem (index) {
      this.extraFields.splice(index, 1)
    },
    handleFieldAdded (field) {
      this.extraFields.push(field)
    },
    handleFieldEdited (field, index) {
      this.extraFields[index] = field
    },
    checkSave() {
      this.member.role === 'Agent' ? this.clickSaveCustomLink() : this.clickSave()
    },
    clickSave() {
      if (!this.$refs.form.validate()) {
        if (!this.formName) {
          this.showMessage(['error', this.$t('error_message.form_name_required')])
        }
        return
      }
      this.isLoading = true
      var memberIds = []
      this.members.forEach(item => {
        if (item.id) {
          memberIds.push(item.id)
        }
      })
      if (this.products.length == 0) {
        this.selectedStyle = 'inquiry'
      }
      if (!this.hasMinOrder) {
        this.minOrderAmount = null
      }
      const params = {
        company : this.company.id,
        name : this.formName,
        // slug : this.formSlug,
        email_enabled : this.customerEmail,
        email_required : this.emailIsRequired,
        layout : this.selectedStyle,
        extra_fields : this.extraFields,
        language: this.formLanguage,
        type: this.formType,
        members: memberIds,
        hide_soldout_products: this.hideSoldoutProducts,
        show_stock: this.showProductStock,
        excluded_zones: this.excludedZones
      }
      if (this.minOrderAmount) {
        params['min_amount'] = (parseFloat(this.minOrderAmount)).toFixed(this.$currency.exponent).replace('.', '')
      } else {
        params['min_amount'] = null
      }
      if (this.extraFields != 0) {
        params['extra_fields'] = this.extraFields
      }
      params['message_template'] = this.messageTemplate
      var productIds = []
      if (this.products.length != 0) {
        this.products.forEach(item => {
          if (item.id) {
            productIds.push(item.id)
          }
        })
        params['products'] = productIds
      }
      if (this.showProductInventory === 'always') {
        params['show_stock_level'] = true
        params['show_stock_level_when_low'] = false
      } else if (this.showProductInventory === 'low') {
        params['show_stock_level'] = false
        params['show_stock_level_when_low'] = true
      } else {
        params['show_stock_level'] = false
        params['show_stock_level_when_low'] = false
      }
      if (this.form) {
        this.axios.put(`/forms/${this.form.id}/`, params)
        .then(resp => {
          this.form = resp.data
          if (this.orderSettings) {
            this.$axios.patch(`/oms/${this.company.slug}/`, { excluded_forms: this.orderSettings.excluded_forms })
              .catch(() => {
                this.showMessage(['error', this.$t('error_message.unable_to_update_order')])
              })
          }
          if (this.customLink) {
            if (this.customLinkId) {
              this.axios.patch(`/forms/${this.form.id}/slugs/${this.customLinkId}/`, { slug: this.customLink })
                .then(() => {
                  this.showMessage(['success', this.$t('success_message.form_updated')])
                  this.showModal = false
                })
                .catch(() => {
                  this.showMessage(['error', this.$t('error_message.unable_to_update_custom_link')])
                })
            } else {
              let data = {
                slug: this.customLink
              }
              this.axios.post(`/forms/${this.form.id}/slugs/`, data)
                .then(() => {
                  this.showMessage(['success', this.$t('success_message.form_updated')])
                  this.showModal = false
                })
                .catch(() => {
                  this.showMessage(['error', this.$t('error_message.unable_to_update_custom_link')])
                })
            }
          } else {
            if (this.customLinkId) {
              this.axios.delete(`/forms/${this.form.id}/slugs/${this.customLinkId}`)
                .then(() => {
                  this.showMessage(['success', this.$t('success_message.form_updated')])
                  this.showModal = false
                })
                .catch(() => {
                  this.showMessage(['error', this.$t('error_message.unable_to_update_custom_link')])
                })
            } else {
              this.showMessage(['success', this.$t('success_message.form_updated')])
              this.showModal = false
            }
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
        return
      }
      this.axios.post(`/forms/`, params)
        .then(resp => {
          let form_id = resp.data.id
          if (this.customLink) {
            let data = {
              slug: this.customLink
            }
            this.$axios.post(`/forms/${form_id}/slugs/`, data)
              .then(() => {
                this.showMessage(['success', this.$t('success_message.form_created')])
                this.showModal = false
              })
              .catch(() => {
                this.showMessage(['error', this.$t('error_message.unable_to_update_custom_link')])
              })
          } else {
            this.showMessage(['success', this.$t('success_message.form_created')])
            this.showModal = false
          }
          this.$emit('added', resp.data)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    clickSaveCustomLink() {
      if (this.customLink) {
        if (this.customLinkId) {
          this.axios.patch(`/forms/${this.form.id}/slugs/${this.customLinkId}/`, { slug: this.customLink })
            .then(() => {
              this.showMessage(['success', this.$t('success_message.form_updated')])
              this.showModal = false
            })
            .catch(() => {
              this.showMessage(['error', this.$t('error_message.unable_to_update_custom_link')])
            })
        } else {
          let data = {
            slug: this.customLink,
            member: this.member.id
          }
          this.axios.post(`/forms/${this.form.id}/slugs/`, data)
            .then(() => {
              this.showMessage(['success', this.$t('success_message.form_updated')])
              this.showModal = false
            })
            .catch(() => {
              this.showMessage(['error', this.$t('error_message.unable_to_update_custom_link')])
            })
        }
      } else {
        if (this.customLinkId) {
          this.axios.delete(`/forms/${this.form.id}/slugs/${this.customLinkId}`)
            .then(() => {
              this.showMessage(['success', this.$t('success_message.form_updated')])
              this.showModal = false
            })
            .catch(() => {
              this.showMessage(['error', this.$t('error_message.unable_to_update_custom_link')])
            })
        } else {
          this.showMessage(['success', this.$t('success_message.form_updated')])
          this.showModal = false
        }
      }
    },
    onFilterChanged () {
      // setTimeout(() => {
      //   this.$refs.selectProducts.isMenuActive = false
      // }, 50)
    },
    onMemberFilterChanged () {
      // setTimeout(() => {
      //   this.$refs.selectMembers.isMenuActive = false
      // }, 50)
    },
    openLayoutSelect () {
      const clickEvent = new MouseEvent('click', {
        'view': window,
        'bubbles': true,
        'cancelable': false
      })
      this.$refs.layoutSelect.$refs.input.dispatchEvent(clickEvent)
    },
    removeProd (item) {
      let index = this.products.map(m => { return m.id}).indexOf(item.id)
      if (index >= 0) this.products.splice(index, 1)
      this.$refs.selectProducts.isMenuActive = false
    },
    removeSales (item) {
      let index = this.members.map(m => { return m.id}).indexOf(item.id)
      if (index >= 0) this.members.splice(index, 1)
    }
  }
}
</script>

<style scoped>
.product-list-title {
  color:#2E2E2E;
  size: 9px;
  font-weight: bold;
}
.product-list-description {
  color: #2E2E2E;
  font-size: 12px;
  white-space: pre-wrap;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "form_name": {
      "label": "Form Name",
      "placeholder": "Write form name here"
    },
    "create_wa_form": "Create WhatsApp Form",
    "edit_wa_form": "Edit WhatsApp Form",
    "customer_explain": "Check or add any extra information that should appear in your customer form.",
    "use_wa_form": "Use WhatsApp Form in",
    "display_product_inventory": "Display products inventory quantity",
    "allow_proceed_to": "Allow proceed to payment without messagings",
    "this_form_has": "This form has minimum order amount"
  },
  "id": {
    "form_name": {
      "label": "Nama Form",
      "placeholder": "Ketik Nama form di sini"
    },
    "create_wa_form": "Buat WhatsApp Form",
    "edit_wa_form": "Edit WhatsApp Form",
    "customer_explain": "Periksa atau tambahkan informasi tambahan apa pun yang akan muncul di form pelanggan kamu.",
    "use_wa_form": "Guna WhatsApp Form di",
    "display_product_inventory": "Tampilkan stok produk",
    "allow_proceed_to": "Izinkan melanjutkan ke pembayaran tanpa pesan",
    "this_form_has": "Form ini memiliki jumlah pesanan minimum"
  }
}
</i18n>
